import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { colors, Button } from '@material-ui/core';
import { Image } from 'components/atoms';
import { SectionHeader } from 'components/molecules';
import { Section } from 'components/organisms';

const useStyles = makeStyles(theme => ({
  root: {
    background: colors.indigo[500],
    position: 'relative',
  },
  header: {
    [theme.breakpoints.up('md')]: {
      position: 'absolute',
      top: '40%',
      right: 0,
      maxWidth: '50%',
      transform: 'translateY(-50%)',
    },
  },
  image: {
    position: 'relative',
    bottom: theme.spacing(-1),
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  textWhite: {
    color: 'white',
  },
}));

const AboutMiddle = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div className={clsx(classes.root, className)} {...rest}>
      <Section className={classes.header}>
        <SectionHeader
          title={
            <span className={classes.textWhite}>
              Athlete program
            </span>
          }
          subtitle={
            <span className={classes.textWhite}>
              For those pursuing an outside sport, dance, or an acting career, our Athletics program combines a rigorous curriculum with a flexible, self-paced schedule, allowing for students to fully tailor their academic experience around their passions. This program is perfect for students who seek an education without disrupting their busy schedules.
            </span>
          }
          ctaGroup={[
            <Button variant="contained" size="large">
              Get started
            </Button>,
          ]}
          align="left"
          className={classes.sectionHeader}
          disableGutter
          data-aos="fade-up"
        />
      </Section>
      <Image
        src="/images/illustrations/people-in-sofa.svg"
        className={classes.image}
        data-aos="fade-up"
      />
    </div>
  );
};

AboutMiddle.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default AboutMiddle;
